/* eslint-disable  @typescript-eslint/no-explicit-any */
import VodDetails from '@/features/VOD/vodClasses/vodDetails'
import { AdditionalRatingToya } from '@/types/vod/VodItemDetails'
import { getDurationInMinutes } from '@/shared/lib'

export function mapToVodDetails(data: any): VodDetails {
    return new VodDetails({
        actionButtons: data.actionButtons ?? [],
        additionalRating:
            (data.parentalRatings?.map((rating: any) => ({
                boxColor: '',
                symbol: `${rating.rating} ${rating.system}`,
                textColor: rating.system,
            })) as AdditionalRatingToya) || [],
        atmosphericUrl:
            data.images?.find(
                (img: any) =>
                    img.size === 'large' && img.orientation === 'landscape'
            )?.url ?? '',
        aspectRatio: data.aspectRatio ?? '16:9', // Default to 16:9 if undefined
        cast:
            data.credits
                ?.filter((credit: any) => credit.role === 'Actor')
                .map((actor: any) => actor.name) || [],
        channelName: data.channelName ?? '',
        country: data.countryOfOrigin ?? '',
        coverUrl:
            data.images?.find(
                (img: any) =>
                    img.size === 'medium' && img.orientation === 'portrait'
            )?.url ?? '',
        crew:
            data.credits
                ?.filter((credit: any) => credit.role !== 'Actor')
                .map((crew: any) => `${crew.name} (${crew.role})`)
                .join(', ') || '',
        description: data.description ?? data.longDescription ?? '',
        duration:
            (data.startTime &&
                data.endTime &&
                getDurationInMinutes(data.startTime, data.endTime)) ||
            data.runtime ||
            0,
        entitlementEndInfo: data.entitlementEndInfo ?? null,
        genres: data.genres || [],
        isPurchased: data.isPurchased ? 1 : 2,
        isFavorite: data.isFavorite ?? false,
        pcLevel: data.pcLevel ?? '',
        price: data.price ?? 0,
        priceLabel: data.priceLabel ?? '',
        productId: data.id ?? '',
        productType: data.type ?? '',
        shortDescription: data.shortDescription ?? '',
        timeOfEvent: data.timeOfEvent ?? null,
        title: data.title ?? 'Untitled',
        trailerProductId: data.trailerProductId ?? '',
        trailerProductType: data.trailerProductType ?? '',
        year: data.releaseDate ? new Date(data.releaseDate).getFullYear() : NaN,
        offers: data.offers || [],
        seasons: data.seasons || [],
        channelId: data.channelId || [],
        serviceName: data.serviceName || [],
    })
}
